const redirectToNotificationsWhenReturnHome = () => null;

export { redirectToNotificationsWhenReturnHome };
